import { render, staticRenderFns } from "./knowledge-base-action-input.vue?vue&type=template&id=4625b529&scoped=true"
import script from "./knowledge-base-action-input.vue?vue&type=script&lang=js"
export * from "./knowledge-base-action-input.vue?vue&type=script&lang=js"
import style0 from "./knowledge-base-action-input.vue?vue&type=style&index=0&id=4625b529&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4625b529",
  null
  
)

export default component.exports